import Immutable from 'immutable';

export const mergeVersionsMaps = function(objectOrg, objectNew) {
    return objectOrg.mergeWith((oldValue, newValue) => (newValue > oldValue ? newValue : oldValue), objectNew);
};

export const mergeWithVersions = function(objectOrg, objectNew) {
    const NO_VERSION = -1;
    const VERSION_MAP_KEY = 'versionsMap';

    if (!Immutable.Map.isMap(objectOrg)) {
        return objectNew;
    }

    return objectOrg.mergeWith((oldValue, newValue, key) => {
        if (Immutable.Map.isMap(newValue)) {
            return key === VERSION_MAP_KEY
                ? mergeVersionsMaps(oldValue, newValue)
                : mergeWithVersions(oldValue, newValue);
        }
        let versionOrg = objectOrg.get(VERSION_MAP_KEY, Immutable.Map()).get(key, NO_VERSION);
        let versionNew = objectNew.get(VERSION_MAP_KEY, Immutable.Map()).get(key, NO_VERSION);
        if (versionNew === NO_VERSION && versionOrg === NO_VERSION) {
            return newValue;
        }
        return versionNew > versionOrg ? newValue : oldValue;
    }, objectNew);
};
